(() => {
  const LONGSLEEVE_LENGTHS = { S: '68', M: '71', L: '74' };
  const LONGSLEEVE_SLEEVES = { S: '61', M: '62', L: '63' };
  const LONGSLEEVES_URL = '/collections/longsleeves-1';

  const isProductPage = () => Boolean(document.querySelector('.mr-product-panel, .mr-product-title, form[action*="/cart/add"]'));
  const isLongsleeveProduct = () => {
    const pageText = [document.querySelector('.mr-product-title')?.textContent || '', document.querySelector('[data-product-title]')?.textContent || '', document.title || '', window.location.pathname || ''].join(' ');
    return /long\s*sleeve|longsleeve/i.test(pageText);
  };
  const isLongsleevesCollection = () => {
    const pageText = [window.location.pathname || '', document.querySelector('.mr-section__title')?.textContent || '', document.title || ''].join(' ');
    return /collections\/.{0,30}long|long\s*sleeves|longsleeves/i.test(pageText);
  };

  const disableScrollReveal = () => {
    if (!document.getElementById('mr-disable-scroll-reveal')) {
      const style = document.createElement('style');
      style.id = 'mr-disable-scroll-reveal';
      style.textContent = `
        .mr-reveal,
        .mr-reveal.is-visible {
          opacity: 1 !important;
          transform: none !important;
          transition: none !important;
          transition-delay: 0s !important;
        }
      `;
      document.head.appendChild(style);
    }

    document.querySelectorAll('.mr-reveal').forEach((node) => {
      node.classList.add('is-visible');
      node.style.opacity = '1';
      node.style.transform = 'none';
      node.style.transition = 'none';
    });
  };

  const addLongsleevesNavLink = () => {
    const desktopAutumn = Array.from(document.querySelectorAll('.mr-header__menu .mr-link')).find((link) => /herbst/i.test(link.textContent));
    if (desktopAutumn && !document.querySelector('.mr-header__menu [data-longsleeves-nav]')) {
      const link = document.createElement('a');
      link.className = 'mr-link';
      link.href = LONGSLEEVES_URL;
      link.textContent = 'LONGSLEEVES';
      link.setAttribute('data-longsleeves-nav', 'true');
      desktopAutumn.insertAdjacentElement('afterend', link);
    }

    const mobileAutumn = Array.from(document.querySelectorAll('.mr-mobile-drawer__nav .mr-mobile-drawer__link')).find((link) => /herbst/i.test(link.textContent));
    if (mobileAutumn && !document.querySelector('.mr-mobile-drawer__nav [data-longsleeves-nav]')) {
      const link = document.createElement('a');
      link.className = 'mr-mobile-drawer__link';
      link.href = LONGSLEEVES_URL;
      link.textContent = 'LONGSLEEVES';
      link.setAttribute('data-longsleeves-nav', 'true');
      mobileAutumn.insertAdjacentElement('afterend', link);
    }
  };

  const addClassicTrustStyles = () => {
    if (document.getElementById('mr-classic-trust-style')) return;
    const style = document.createElement('style');
    style.id = 'mr-classic-trust-style';
    style.textContent = `
      .mr-product-panel .mr-assurance.mr-assurance--classic,
      .mr-assurance.mr-assurance--classic {
        margin: .95rem 0 1.2rem !important;
        padding: .15rem 0 .2rem !important;
        border: 0 !important;
        border-color: transparent !important;
        border-radius: 0 !important;
        outline: 0 !important;
        background: none !important;
        background-color: transparent !important;
        background-image: none !important;
        box-shadow: none !important;
        filter: none !important;
      }

      .mr-assurance.mr-assurance--classic::before,
      .mr-assurance.mr-assurance--classic::after,
      .mr-assurance--classic *::before,
      .mr-assurance--classic *::after {
        box-shadow: none !important;
        border-color: transparent !important;
        background-image: none !important;
      }

      .mr-assurance--classic .mr-assurance__eyebrow,
      .mr-assurance--classic .mr-origin,
      .mr-assurance--classic .mr-payment-icons {
        display: none !important;
      }

      .mr-assurance--classic .mr-social-proof {
        display: block !important;
        margin: 0 0 .72rem !important;
        padding: 0 !important;
        border: 0 !important;
        background: transparent !important;
        box-shadow: none !important;
        color: rgba(24, 34, 56, .74) !important;
        font-size: clamp(12px, 1vw, 14px) !important;
        line-height: 1.35 !important;
        letter-spacing: .01em !important;
      }

      .mr-assurance--classic .mr-social-proof__avatars {
        display: none !important;
      }

      .mr-assurance--classic .mr-social-proof strong {
        color: #0b1730 !important;
        font-weight: 600 !important;
      }

      .mr-assurance--classic .mr-trust-grid {
        display: grid !important;
        grid-template-columns: 1fr !important;
        gap: .5rem !important;
        margin: 0 !important;
        padding: 0 !important;
        border: 0 !important;
        background: transparent !important;
        box-shadow: none !important;
      }

      .mr-assurance--classic .mr-trust-item {
        display: flex !important;
        align-items: center !important;
        gap: .66rem !important;
        padding: .08rem 0 !important;
        border: 0 !important;
        border-radius: 0 !important;
        background: transparent !important;
        box-shadow: none !important;
        color: #182238 !important;
        font-size: clamp(13px, 1.1vw, 15px) !important;
        font-weight: 400 !important;
        letter-spacing: .01em !important;
        line-height: 1.35 !important;
      }

      .mr-assurance--classic .mr-trust-item__icon {
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        width: 21px !important;
        height: 21px !important;
        flex: 0 0 21px !important;
        border: 0 !important;
        border-radius: 0 !important;
        outline: 0 !important;
        background: transparent !important;
        box-shadow: none !important;
        color: #9d7a38 !important;
        font-family: Georgia, serif !important;
        font-size: 17px !important;
        line-height: 1 !important;
      }

      .mr-assurance--classic + .mr-accordion {
        border-top-color: rgba(24, 34, 56, .13) !important;
      }
    `;
    document.head.appendChild(style);
  };

  const updateCustomerWording = () => {
    document.querySelectorAll('.mr-social-proof').forEach((node) => {
      if (!/(12[.,]739|12739|590|Hunderte Kunden)/.test(node.textContent)) return;
      node.innerHTML = '<strong>Hunderte Kunden</strong> lieben Maison Rivage';
    });
  };

  const stripAssuranceBoxStyles = (assurance) => {
    ['border', 'borderColor', 'borderRadius', 'outline', 'background', 'backgroundColor', 'backgroundImage', 'boxShadow', 'filter'].forEach((property) => {
      assurance.style[property] = property === 'borderColor' ? 'transparent' : property === 'backgroundColor' ? 'transparent' : property === 'backgroundImage' ? 'none' : property === 'borderRadius' ? '0' : property === 'boxShadow' ? 'none' : property === 'filter' ? 'none' : '0';
    });
  };

  const makeTrustClassic = () => {
    const panel = document.querySelector('.mr-product-panel');
    const assurance = panel?.querySelector('.mr-assurance');
    const firstAccordion = panel?.querySelector('.mr-accordion');
    if (!panel || !assurance) return;

    assurance.classList.add('mr-assurance--classic');
    stripAssuranceBoxStyles(assurance);
    addClassicTrustStyles();
    updateCustomerWording();

    const grid = assurance.querySelector('.mr-trust-grid');
    if (!grid) return;

    const labels = ['In Deutschland designt & bedruckt', 'Versand in DE & EU', '14 Tage Rückgabe', 'Zeitloses Design'];
    const icons = ['✦', '✈', '↩', '✧'];
    const items = Array.from(grid.querySelectorAll('.mr-trust-item'));

    labels.forEach((label, index) => {
      let item = items[index];
      if (!item) {
        item = document.createElement('div');
        item.className = 'mr-trust-item';
        item.innerHTML = '<span class="mr-trust-item__icon"></span><span></span>';
        grid.appendChild(item);
      }
      const icon = item.querySelector('.mr-trust-item__icon');
      const text = item.querySelector('span:last-child');
      if (icon) icon.textContent = icons[index];
      if (text) text.textContent = label;
      item.style.display = '';
    });

    Array.from(grid.querySelectorAll('.mr-trust-item')).slice(labels.length).forEach((item) => item.remove());

    if (firstAccordion && firstAccordion.previousElementSibling !== assurance) {
      firstAccordion.insertAdjacentElement('beforebegin', assurance);
    }
  };

  const addLongsleevesCollectionStyles = () => {
    if (!isLongsleevesCollection()) return;
    document.documentElement.classList.add('mr-longsleeves-collection');
    if (document.getElementById('mr-longsleeves-collection-style')) return;
    const style = document.createElement('style');
    style.id = 'mr-longsleeves-collection-style';
    style.textContent = `.mr-longsleeves-collection .mr-hero{min-height:34vh!important;height:min(42vh,390px)!important}.mr-longsleeves-collection .mr-hero__content{padding-top:3.5rem!important;padding-bottom:2.8rem!important}.mr-longsleeves-collection .mr-hero__title{font-size:clamp(2.4rem,5.5vw,4.4rem)!important;margin-bottom:1.2rem!important}.mr-longsleeves-collection .mr-editorial{min-height:0!important}.mr-longsleeves-collection .mr-editorial__block{min-height:clamp(220px,34vw,340px)!important}@media(max-width:760px){.mr-longsleeves-collection .mr-hero{min-height:28vh!important;height:300px!important}.mr-longsleeves-collection .mr-editorial__block{min-height:220px!important}}`;
    document.head.appendChild(style);
  };

  const updateSizeChartRows = (root) => {
    root.querySelectorAll('tr').forEach((row) => {
      const cells = Array.from(row.children);
      if (cells.length < 3) return;
      const size = cells[0].textContent.trim().toUpperCase();
      if (!LONGSLEEVE_LENGTHS[size]) return;
      cells[1].textContent = LONGSLEEVE_LENGTHS[size];
      cells[2].textContent = LONGSLEEVE_SLEEVES[size];
    });

    root.querySelectorAll('.mr-size-chart__row, .size-chart__row, .size-guide__row').forEach((row) => {
      const cells = Array.from(row.children);
      const sizeCell = cells.find((cell) => /^(S|M|L)$/i.test(cell.textContent.trim()));
      if (!sizeCell) return;
      const size = sizeCell.textContent.trim().toUpperCase();
      const sizeIndex = cells.indexOf(sizeCell);
      const lengthCell = cells[sizeIndex + 1];
      const sleeveCell = cells[sizeIndex + 2];
      if (lengthCell && LONGSLEEVE_LENGTHS[size]) lengthCell.textContent = LONGSLEEVE_LENGTHS[size];
      if (sleeveCell && LONGSLEEVE_SLEEVES[size]) sleeveCell.textContent = LONGSLEEVE_SLEEVES[size];
    });
  };

  const updateInlineLengthText = (root) => {
    root.querySelectorAll('li, p, span, div, td, th').forEach((node) => {
      if (node.children.length > 0) return;
      let value = node.textContent;
      Object.entries(LONGSLEEVE_LENGTHS).forEach(([size, length]) => {
        value = value.replace(new RegExp('\\b' + size + '\\b\\s*:?\\s*\\d+(?:[,.]\\d+)?\\s*cm', 'gi'), size + ': ' + length + ' cm');
      });
      if (value !== node.textContent) node.textContent = value;
    });
  };

  const updateLongsleeveMeasurements = () => {
    if (!isProductPage() || !isLongsleeveProduct()) return;
    updateSizeChartRows(document);
    updateInlineLengthText(document);
  };

  const applyProductLayoutFixes = () => {
    disableScrollReveal();
    addLongsleevesNavLink();
    addLongsleevesCollectionStyles();
    makeTrustClassic();
    updateLongsleeveMeasurements();
  };

  const scheduleFix = () => window.requestAnimationFrame(applyProductLayoutFixes);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scheduleFix);
  else scheduleFix();

  document.addEventListener('click', (event) => {
    if (event.target.closest('#mr-open-size-guide, .mr-size-guide, .mr-accordion__trigger, [data-mobile-menu-toggle]')) {
      window.setTimeout(applyProductLayoutFixes, 50);
      window.setTimeout(applyProductLayoutFixes, 200);
      window.setTimeout(applyProductLayoutFixes, 500);
    }
  });

  const observer = new MutationObserver(scheduleFix);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();